import React from 'react';
import { useTranslation } from 'react-i18next';

import SilaNavTabs from '../common/SilaNavTabs';
import AppFeaturesForm from './AppFeaturesForm';

import { adminApi } from '../../api';
import { useAlerts } from '../context';

function AppCapabilities({ enabledFeatures, setEnabledFeatures, id, handle }) {
  const { t } = useTranslation();
  const { setAlert } = useAlerts();

  const handleUpdateAppFeature = async (feature) => {
    const updateObj = {};
    updateObj[feature] = !enabledFeatures.includes(feature);

    try {
      const response = await adminApi.updateAppFeature(id, updateObj);
      setAlert({
        message: t('admin.applications.detail.enabledAppFeatures.success', {
          handle: handle,
        }),
        variant: 'success',
      });
      setEnabledFeatures(response.enabled_features || []);
    } catch (error) {
      setAlert({ message: error, variant: 'warning' });
    }
  };

  const tabs = [
    {
      key: 'features',
      label: t('applications.buttons.features'),
      component: (
        <AppFeaturesForm enabledFeatures={enabledFeatures} onSubmit={handleUpdateAppFeature} />
      ),
    },
  ];

  return <SilaNavTabs tabs={tabs} defaultTab="features" />;
}

export default AppCapabilities;
